import React, {useState} from 'react'

import {images} from '../../constants'
import {AppWrap, MotionWrap } from '../../wrapper'
import {client} from '../../client'
import './Footer.scss'


const Footer = () => {

  const [formData, setFormData] = useState({name: '', email: '', message: ''})
  const [isFormSubmitter, setIsFormSubmitter] = useState(false)
  const [loading, setLoading] = useState(false)

  const {name , email, message } = formData   // destructring the oject. as formData.name value comes in name, same with other value

  const handleChangeInput = (e) => {
    const {name,value} = e.target
    setFormData({...formData, [name]:value})  // from where it has been called for those key's value changes in formData 
  }

  const handleSubmit = () => {
    setLoading(true)

    const contact = {
      _type: 'contact',
      name: name,
      email: email,
      message: message
    }

    // first time i've upload data from our website to the backend sanity
    client.create(contact).then(() => {     // this function runs in a response we get from backend
      setLoading(false)                   // then loading becomes false
      setIsFormSubmitter(true)            // and sucessfull form submitted message appears
    })

  }


  return (
  <>
    <h2 className="head-text"> feel free to contact</h2>

    <div className="app__footer-cards app__flex">
      <a style={{textDecoration: 'none'}} href="mailto: aygupta9334@gmail.com" className='app__footer-card p-text'>
        <img src={images.email} alt="email" />  
        <span>Mail Mef</span>
      </a>
      <a style={{textDecoration: 'none'}} href="tel: +91 9334608414" className='app__footer-card p-text'>
        <img src={images.mobile} alt="phone" />
        <span>Contact Me</span>
      </a>
    </div>

    { isFormSubmitter ? ( 
      <div>
        <h3 className="head-text">
          ThankYou to getting in touch! 
        </h3>
      </div>  
    )
      :
    (  
      <div className="app__footer-form app__flex">
        <div>
          <input className='p-text' type="text" name="name" value={name} placeholder='Your Name...' onChange={handleChangeInput}/>
        </div>
        <div>
          <input className='p-text' type="email" name="email" value={email} placeholder='Your Email...' onChange={handleChangeInput}/>
        </div>
        <div>
          <textarea className='p-text' name="message" value={message} placeholder='Your Message...' onChange={handleChangeInput}/>
        </div>
        
        <button className="p-text" onClick={handleSubmit}>{loading ? 'Sending...' : 'Submit'} </button>

      </div>
    )
    }
  </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__primarybg'
)